module.exports = __webpack_public_path__ + "img/jianwai.5cc76311.jpg";